/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import React from 'react';

interface BarChartProps {
    data: {
        labels: string[];
        datasets: {
            label: string;
            data: number[];
            backgroundColor?: string;
        }[];
    };
}

export const BarChart: React.FC<BarChartProps> = ({ data }) => {
    const maxValue = Math.max(...data.datasets[0].data);
    const yAxisLabels = Array.from({ length: 5 }, (_, i) => Math.ceil(maxValue / 4) * i).reverse();

    return (
        <div className="w-full h-64 p-4 bg-gray-50 dark:bg-black/20 rounded-lg">
            <div className="flex h-full">
                <div className="flex flex-col justify-between text-[10px] text-gray-400">
                    {yAxisLabels.map(label => <span key={label}>{label.toLocaleString()}</span>)}
                </div>
                <div className="flex-1 grid grid-cols-7 gap-2 ml-2">
                    {data.datasets[0].data.map((value, index) => (
                        <div key={index} className="flex flex-col items-center justify-end group">
                            <div className="text-xs font-bold opacity-0 group-hover:opacity-100 transition-opacity text-gray-700 dark:text-gray-200">${value.toLocaleString()}</div>
                            <div
                                className="w-full rounded-t-md"
                                style={{
                                    height: `${(value / maxValue) * 100}%`,
                                    backgroundColor: data.datasets[0].backgroundColor || '#C5A059',
                                }}
                            ></div>
                            <span className="text-[10px] text-gray-500 mt-1">{data.labels[index]}</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};
